
import './navSwitcherSections.scss';

/**************
 * 
 * Docs:
 * use on Toggle Sections 
 * class = "navSwitch"
 * use data Attributes
 *  data-navClass="nav-transBG-white"
 *  data-navClass="nav-darkBG-white"
 *  data-navClass="nav-brightBG-dark"
 * 
 *  */



class NavSwitcherSections {
    constructor(options = {}) {
        this.options = options;
        this.scrollData = {
            direction: undefined,
            prevPosition: 0
        }
        this.DOM = {
            sections: [...document.querySelectorAll('.navSwitch')],
            navis: [document.getElementById('offcanvas-nav')]
        }
        this.DOM.sectionCount = this.DOM.sections.length;

        this.navClasses = ["nav-transBG-white", "nav-darkBG-white", "nav-brightBG-dark",]
        this.initStartNav()


        this.observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                this.setScrollDirection()
                if (this.scrollData.direction === 'down' && entry.intersectionRatio === 0) {
                    this.changeNaviClass(this.getNavClassDownScroll(entry));
                }
                if (this.scrollData.direction === 'up' && entry.intersectionRatio > 0) {
                    this.changeNaviClass(entry.target.dataset.navclass);
                }
                if (this.scrollData.direction === 'notScrolled') {
                    this.changeNaviClass(this.startClass);
                }
            });
        }, {
            rootMargin: `${this.DOM.navis[0].offsetHeight * -1}px`,
            threshold: 0
        });
        this.addEvents()
    }
    initStartNav = () => {

        this.DOM.navis.forEach(navi => { navi.style.position = 'fixed', navi.style.width = "100vw" });
        // const startClassDesk = [...this.DOM.navis[0].classList].filter(element => this.navClasses.includes(element))[0]
        const startClassOffcanv = [...this.DOM.navis[0].classList].filter(element => this.navClasses.includes(element))[0]
        // if (!startClassDesk) console.warn('Nav Config warning or no startClass Desktop')
        if (!startClassOffcanv) console.warn('Nav Config warning or no startClass offcanvas')
        this.startClass = startClassOffcanv;

    }
    addEvents = () => {
        this.DOM.sections.forEach(section => this.observer.observe(section))
    }

    setScrollDirection = () => {
        this.scrollData.direction = document.documentElement.scrollTop > this.scrollData.prevPosition ? "down" : "up";
        if (document.documentElement.scrollTop > this.scrollData.prevPosition) {
            this.scrollData.direction = "down"
        }
        else if (document.documentElement.scrollTop < this.scrollData.prevPosition) {
            this.scrollData.direction = "up"
        } else {
            this.scrollData.direction = "notScrolled"
        }
        this.scrollData.prevPosition = document.documentElement.scrollTop;
    }

    changeNaviClass = (nextClass) => {
        this.DOM.navis.forEach(navi => {
            navi.classList.remove(...this.navClasses)
            navi.classList.add(nextClass)
        })
    }

    getNavClassDownScroll = (entry) => {
        const currentSection = this.DOM.sections.findIndex((el) => el === entry.target)
        const nextSectionIndex = (currentSection < this.DOM.sectionCount - 1) ? currentSection + 1 : currentSection
        return this.DOM.sections[nextSectionIndex].dataset.navclass
    }
}

export {
    NavSwitcherSections
}